import{useState as a}from"react";function r(r,e){var c=a((function(){return{value:r,callback:e,facade:{get current(){return c.value},set current(a){var r=c.value;r!==a&&(c.value=a,c.callback(a,r))}}}}))[0];return c.callback=e,c.facade}export{r as useCallbackRef};
//# sourceMappingURL=useRef.js.map
